import React from 'react'
import clsx from 'clsx'
import { useRouter } from 'next/compat/router'

import { Link as LinkMUI, LinkProps as LinkMUIProps } from '@mui/material'
import NextLink, { LinkProps as NextLinkProps } from 'next/link'

import getRoutes from '@/lib/getRoutes'

export type LinkProps = Omit<LinkMUIProps, 'href' | 'classes'> &
  Pick<NextLinkProps, 'href' | 'as' | 'prefetch'>

function LinkWrapped(props) {
  const {
    activeClassName = 'active',
    color = 'textPrimary',
    className: classNameProps,
    ref: innerRef,
    naked,
    prefetch,
    useClassicLink = false,
    ...other
  } = props
  const router = useRouter()

  const className = clsx(classNameProps, {
    [activeClassName]: router?.pathname === props.href && activeClassName,
  })

  // @ts-ignore
  const { href, as } = props.route ? getRoutes({ ...props }) : { ...props }

  if (naked) {
    return (
      <NextLink className={className} ref={innerRef} href={href} as={as} prefetch={prefetch}>
        {other.children}
      </NextLink>
    )
  } else if (useClassicLink) {
    return (
      <LinkMUI
        underline="none"
        href={href}
        className={className}
        ref={innerRef}
        color={color}
        {...other}
      >
        {other.children}
      </LinkMUI>
    )
  }

  return (
    <NextLink
      href={href}
      prefetch={prefetch}
      as={as}
      passHref
      legacyBehavior
      style={{ textDecoration: 'none' }}
    >
      <LinkMUI
        underline="none"
        className={className}
        ref={innerRef}
        color={color}
        style={props.style}
      >
        {other.children}
      </LinkMUI>
    </NextLink>
  )
}

export default React.forwardRef<HTMLAnchorElement, LinkProps>((props, ref) => (
  <LinkWrapped {...props} ref={ref} />
))
